import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import HomeIcon from '../../../images/house.svg'

const Image = styled.img`
  width: 32px;
`
const StyledLink = styled(Link)`
  width: 32px;
  height: 32px;
`

const HomeButton = ({ ...props }) => {
    return (
      <StyledLink to='/'>
        <Image src={HomeIcon} {...props} />
      </StyledLink>
    )
}

export default HomeButton
